import React from 'react';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { useDeleteCharitableGivingGoalMutation } from '../../api/useDeleteCharitableGivingGoalMutation';
import { toast } from '../../../CommonComponents/OPL/Toast/Toast';
import { MESSAGES } from '../../../CommonConstants';

interface Props {
  goalId: string;
  onClose(): void;
}

export const DeleteGoalModal = ({ goalId, onClose }: Props) => {
  const {
    mutateAsync: deleteGoal,
    isLoading: isDeletingGoal,
  } = useDeleteCharitableGivingGoalMutation();

  const onDeleteGoal = async () => {
    try {
      await deleteGoal({ goalId });

      onClose();
    } catch {
      toast.error(MESSAGES.GENERIC_ERROR);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: 'delete-charitable-giving-goal--modal-header' }}
    >
      <ModalHeader as="h2" id="delete-charitable-giving-goal--modal-header" variant="warning">
        Are you sure you want to delete this goal?
      </ModalHeader>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button onClick={onDeleteGoal} isLoading={isDeletingGoal} variant="error" ml="8">
          Delete Goal
        </Button>
      </ModalFooter>
    </Modal>
  );
};
